module.exports = __webpack_public_path__ + "static/media/bullet-arrow.49734cb6.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/bullet-arrow.svg
// module id = 128
// module chunks = 0